module.exports = "/packs/images/pages/boroughs/borough-activity-facility-filter~a92be3089845ff03cecd8b6d33724261.jpg";